var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "67px",
    height: "58px",
    viewBox: "0 0 67 58",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "657395DE-3EEB-4B2F-87E0-3EBCB77B2377") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4.-Key-Facts-about-Hana",
    transform: "translate(-352.000000, -527.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(354.000000, 529.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(0.000000, 0.227925)",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.5823502,49.7652339 C27.8860137,57.2641223 11.5138604,53.0509327 4.01454521,40.3541695 C-3.48391637,27.6574063 0.728846368,11.2856798 13.4251828,3.78679139 C26.1215192,-3.71252384 42.4932457,0.501092549 49.9925609,13.1978558",
    id: "Stroke-1",
    stroke: "#252855",
    strokeWidth: 3.16106594
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-3",
    stroke: "#ED7330",
    strokeWidth: 2.40900029,
    strokeLinejoin: "round",
    points: "44.266234 18.4134012 58.5751153 21.4156882 62.8625724 7.39021876 53.680713 12.8330911"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6960174,6.45854515 L25.6960174,9.76174382 M12.4977347,11.9257466 L14.8333211,14.261333 M7.03096016,25.1240292 L10.3341588,25.1240292 M12.4977347,38.3227386 L14.8333211,35.9871522 M25.6960174,43.78994 L25.6960174,40.4867414",
    id: "Stroke-5",
    stroke: "#ED7330",
    strokeWidth: 3.16106594
  })), /*#__PURE__*/React.createElement("text", {
    id: 12,
    fontFamily: "Gotham-Black, Gotham",
    fontSize: 19.656529,
    fontWeight: 700,
    fill: "#252855"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 18.0220166,
    y: 32.0371182
  }, "12")))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.5b8ad015.svg";
export { ForwardRef as ReactComponent };